import { render, staticRenderFns } from "./FactorSelectionNodes.vue?vue&type=template&id=70d46bfd&scoped=true"
import script from "./FactorSelectionNodes.vue?vue&type=script&lang=ts"
export * from "./FactorSelectionNodes.vue?vue&type=script&lang=ts"
import style0 from "./FactorSelectionNodes.vue?vue&type=style&index=0&id=70d46bfd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70d46bfd",
  null
  
)

export default component.exports